var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContainer"},[(Number(_vm.paramId) === Number(_vm.currentUserInfo.userId))?_c('current-user'):_c('other-user-profile',{attrs:{"userId":Number(_vm.paramId)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }